import { useState } from "react";

import EditMentionModal from "@/containers/EditMentionModal";
import { useEpisode } from "@/containers/Episode/context";
import ExternalLink from "@/containers/Episode/partials/Body/partials/ExternalLink";
import Actions from "@/containers/Episode/partials/Mention/Actions";
import RemoveMention from "@/containers/Episode/partials/Mention/RemoveMention";
import Similar from "@/containers/Episode/partials/Mention/Similar";
import Topic from "@/containers/Episode/partials/Mention/Topic";
import Translate from "@/containers/Episode/partials/Translate";
import { useEpisodes } from "@/contexts/EpisodesContext";
import { useI18n } from "@/contexts/i18nContext";
import { AudioMention } from "@/types/Mention";
import { cx } from "@/utils";
import AccessControl, { ACCESS_LEVELS } from "@components/AccessControl";
import UndoRemovedMention from "@components/UndoRemovedMention";

import styles from "./Mention.module.css";

const Mention: React.FunctionComponent<{
  hideActions?: boolean;
  className?: string;
  mention: AudioMention;
}> = ({ className, mention, hideActions: forceHideActions }) => {
  const { hideActions, hideMetadata, hideSimilar } = useEpisode();
  const { language } = useI18n();

  const [editing, setEditing] = useState(false);
  const { updateMention } = useEpisodes();
  const { removedMentionIds, mentions, channel_language } = useEpisode();

  const isRemoved = removedMentionIds.includes(mention.public_id);
  const allMentionsRemoved = removedMentionIds.length === mentions.length;
  const channelNotInUserLanguage = channel_language !== language;

  return (
    <>
      <div
        className={cx(
          styles.root,
          "mention",
          { marked: mention.marked_irrelevant_at },
          className
        )}
        data-mention-id={mention.public_id}
      >
        <div>
          {isRemoved && !allMentionsRemoved ? (
            <UndoRemovedMention currentId={mention.public_id} />
          ) : (
            <div className={styles.actions}>
              {!hideMetadata && <Topic mention={mention} />}

              {!forceHideActions &&
                !hideActions &&
                channelNotInUserLanguage && <Translate mentions={[mention]} />}
              <ExternalLink />
              {!forceHideActions && !hideActions && (
                <AccessControl level={ACCESS_LEVELS.USER}>
                  <RemoveMention currentId={mention.public_id} />
                  <Actions mention={mention} setEditing={setEditing} />
                </AccessControl>
              )}
            </div>
          )}

          {!hideSimilar && mention.similar?.length > 0 && (
            <Similar
              mentions={mention.similar}
              episode_pk={mention.episode_pk}
            />
          )}
        </div>
      </div>
      <EditMentionModal
        show={editing}
        onHide={() => setEditing(false)}
        mention={mention}
        updateMention={updateMention}
      />
    </>
  );
};

export default Mention;
